<template>
  <div class="con-wrap">
    <p class="box-title">告警记录</p>
    <div class="data-wrap">
      <div class="query-box">
        <el-form ref="queryForm" :model="queryForm" size="mini" :inline="true">
          <el-form-item prop="warnSort">
            <el-select
              v-model="queryForm.warnSort"
              clearable
              placeholder="告警名称"
            >
              <el-option
                v-for="item in alarmName"
                :key="item.code"
                :label="item.value"
                :value="item.code"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="time">
            <date-picker
              :startTime="queryForm.startTime"
              :endTime="queryForm.endTime"
              @changeStart="changeStart"
              @changeEnd="changeEnd"
            >
            </date-picker>
          </el-form-item>
          <el-button type="primary" @click="query">查询</el-button>
          <el-button @click="reset">取消</el-button>
        </el-form>
      </div>
      <div class="data-box">
        <el-table
          ref="multipleTable"
          :data="tableData"
          tooltip-effect="dark"
          style="width: 100%"
          size="mini"
          stripe
          height="560px"
          v-loading="loading"
        >
          <el-table-column
            type="index"
            label="序号"
            align="center"
            width="55"
          ></el-table-column>
          <el-table-column prop="warnName" label="告警名称"></el-table-column>
          <el-table-column prop="startTime" label="开始时间"></el-table-column>
          <el-table-column prop="endTime" label="结束时间"></el-table-column>
          <el-table-column prop="warnType" label="告警状态" width="160">
            <template slot-scope="scope">
              <span v-if="scope.row.warnType == 2" class="btn-green"
                >告警解除</span
              >
              <span v-else-if="scope.row.warnType == 1" class="btn-red"
                >告警中</span
              >
            </template>
          </el-table-column>
          <!-- ？？？操作新增 -->
          <!-- <el-table-column label="操作">
            <template slot-scope="{ row }">
              <el-button type="text" @click="toAlarmDetails(row)"
                >详情</el-button
              >
            </template>
          </el-table-column> -->
        </el-table>
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page.sync="currentPage"
          :page-size="limit"
          layout="total, prev, pager, next, jumper"
          :total="total"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import DatePicker from "@/components/DatePicker.vue";
export default {
  name: "AlarmLog",
  components: {
    DatePicker,
  },
  props: {
    vin: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      queryForm: {
        startTime: "",
        endTime: "",
      },
      loading: false,
      alarmName: [],
      tableData: [],
      currentPage: 1,
      limit: 10,
      total: 0,
    };
  },
  created() {
    this.getAlarmList();
    this.getAlarmData();
  },
  methods: {
    changeStart(val) {
      this.queryForm.startTime = val;
    },
    changeEnd(val) {
      this.queryForm.endTime = val;
    },
    query() {
      this.getAlarmData();
    },
    reset() {
      this.$resetForm(this, "queryForm");
      this.getAlarmData();
    },
    async getAlarmData() {
      let _this = this;
      _this.loading = true;
      let obj = {
        vin: _this.vin,
        page: _this.currentPage,
        limit: _this.limit,
        warnSort: _this.queryForm.warnSort,
        startTime: _this.queryForm.startTime,
        endTime: _this.queryForm.endTime,
      };
      let { data: res } = await _this.$axios.get(
        "/api/vehicle/details/dynamo/warning",
        {
          params: obj,
        }
      );
      if (res.code == 1) {
        _this.loading = false;
        _this.tableData = res.data.list;
        _this.total = res.data.totalCount;
      } else {
        _this.$message.warning(res.msg);
      }
    },
    async getAlarmList() {
      let _this = this;
      let { data: res } = await _this.$axios.get(
        "/api/sys/dict/" + "electricityWarn"
      );
      if (res.code == 1) {
        _this.alarmName = res.data;
      } else {
        _this.$message.warning(res.msg);
      }
    },
    //页数改变时触发
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getAlarmData();
    },
  },
};
</script>

<style lang="scss" scoped>
.con-wrap {
  height: 100%;
  margin: 0;
  background-color: #fff;
}
.con-wrap .box-title {
  padding-bottom: 10px;
  font-size: 16px;
  font-weight: bold;
  background: #f8f8f8;
}
.data-wrap {
  width: 100%;
  height: calc(100% - 31px);
  padding: 20px;
  box-sizing: border-box;
}
.data-box {
  width: 100%;
  height: calc(100% - 84px);
}
</style>
